import React from 'react';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

export const SwitchButton = (props) => {
//   const [checked, setChecked] = React.useState(false);

//   const toggleChecked = () => {
//     setChecked((prev) => !prev);
//   };

  return (
    <FormGroup id="switch-button">
        <div className="label-wrapper">
            <span>{props.labelLeft}</span>
            <FormControlLabel
                control={<Switch checked={props.switchButtonchecked} onChange={props.toggleCheckedSwitchButton} />}
                // label="Normal"
            />
            <span>{props.labelRight}</span>
        </div>

    </FormGroup>
  );
}
